// De regels voor een naam bij de naamstap, voor de browser (NameStep).
//
// Nodig omdat de server (matchQuestionnaireName) dezelfde regels toepast: wijken
// ze af, dan keurt de browser een naam goed die de server weigert, en ziet de
// invuller eindeloos 'probeer het opnieuw'. Eén bestand zonder imports, zodat
// functions/personaMatching/nameStepRules.parity.test.js het tegen de server houdt.
// De frontend is de bron.
//
// AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment
// AI-CONTEXT: See docs/features/deelnemer-koppeling-algemene-link.md

/** Langste voor- of achternaam, na trimmen en samenvoegen van spaties. */
export const MAX_NAME_PART = 60

/** Het lokveld: een bot vult het, een mens ziet het niet. Zelfde naam als de adresstap. */
export const HONEYPOT_KEY = 'website'

// Regelovergangen, tabs en andere stuurtekens horen niet in een naam.
// eslint-disable-next-line no-control-regex
export const CONTROL_CHARS = /[\u0000-\u001F\u007F]/

/**
 * @param {string} value
 * @returns {boolean} Bevat het stuurtekens?
 */
export const hasControlChars = (value) => CONTROL_CHARS.test(String(value ?? ''))

/**
 * Keurt de server dit deel van de naam goed? Getrimd en met samengevoegde
 * spaties niet leeg en niet te lang, en zonder stuurtekens.
 * @param {*} value
 * @returns {boolean}
 */
export const isValidNamePart = (value) => {
    if (typeof value !== 'string' || CONTROL_CHARS.test(value)) return false
    const text = value.trim().replace(/ {2,}/g, ' ')
    return text.length > 0 && text.length <= MAX_NAME_PART
}

export default isValidNamePart
